import React, { useState, useEffect } from 'react';
import SelectModal from './SelectModal';

const TimePickOverlay = ({ isVisible, onClose, onSelect, initialTime }) => {
    const [selectedHour, setSelectedHour] = useState(12);
    const [selectedMinute, setSelectedMinute] = useState(0);
    const [isPM, setIsPM] = useState(false);

    useEffect(() => {
        if (initialTime) {
            // 이미 선택된 시간이 있는 경우
            const [hour, minute] = initialTime.split(':').map(Number);
            setIsPM(hour >= 12);
            setSelectedHour(hour === 0 ? 12 : hour > 12 ? hour - 12 : hour);
            setSelectedMinute(minute);
        } else {
            // 초기 시간 설정 (현재 시간 + 30분, 10분 단위로 올림)
            const now = new Date();
            const minutes = now.getMinutes();
            const hours = now.getHours();

            // 30분을 더하고 10분 단위로 올림
            let targetMinutes = minutes + 30;
            targetMinutes = Math.ceil(targetMinutes / 10) * 10;

            // 분이 60을 넘어가는 경우 시간 조정
            let targetHours = hours + Math.floor(targetMinutes / 60);
            targetMinutes = targetMinutes % 60;

            // 12시간제로 변환
            const isPMValue = targetHours >= 12;
            const hour12 = targetHours === 0 ? 12 : targetHours > 12 ? targetHours - 12 : targetHours;

            setSelectedHour(hour12);
            setSelectedMinute(targetMinutes);
            setIsPM(isPMValue);
        }
    }, [initialTime, isVisible]); // isVisible을 추가하여 오버레이가 열릴 때마다 초기화

    const hours = Array.from({ length: 12 }, (_, i) => i + 1);
    const minutes = [0, 10, 20, 30, 40, 50];

    const handleConfirm = () => {
        let hour24 = selectedHour;
        if (isPM && selectedHour !== 12) {
            hour24 = selectedHour + 12;
        } else if (!isPM && selectedHour === 12) {
            hour24 = 0;
        }

        const formattedTime = `${hour24.toString().padStart(2, '0')}:${selectedMinute.toString().padStart(2, '0')}`;
        onSelect(formattedTime);
        onClose();
    };

    const formatTime = () => {
        const period = isPM ? '오후' : '오전';
        return `${period} ${selectedHour}:${selectedMinute.toString().padStart(2, '0')}`;
    };

    return (
        <SelectModal
            isVisible={isVisible}
            onClose={onClose}
            title="시간 선택"
            onConfirm={handleConfirm}
        >
            {/* 선택된 시간 표시 */}
            <div className="text-center mb-6">
                <div className="text-2xl font-bold text-amber-500">
                    {formatTime()}
                </div>
            </div>

            {/* 오전/오후 토글 */}
            <div className="mb-4">
                <div className="flex bg-gray-100 rounded-lg p-1">
                    <button
                        onClick={() => setIsPM(false)}
                        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                            !isPM
                                ? 'bg-white text-gray-900 shadow-sm'
                                : 'text-gray-500 active:text-gray-700'
                        }`}
                    >
                        오전
                    </button>
                    <button
                        onClick={() => setIsPM(true)}
                        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                            isPM
                                ? 'bg-white text-gray-900 shadow-sm'
                                : 'text-gray-500 active:text-gray-700'
                        }`}
                    >
                        오후
                    </button>
                </div>
            </div>

            {/* 시간 선택 */}
            <div className="mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">시간</h4>
                <div className="grid grid-cols-4 gap-2">
                    {hours.map((hour) => (
                        <button
                            key={hour}
                            onClick={() => setSelectedHour(hour)}
                            className={`p-2 rounded-lg text-sm ${
                                selectedHour === hour
                                    ? 'bg-amber-500 text-white'
                                    : 'bg-gray-100 active:bg-gray-200'
                            }`}
                        >
                            {hour}
                        </button>
                    ))}
                </div>
            </div>

            {/* 분 선택 */}
            <div>
                <h4 className="text-sm font-medium text-gray-700 mb-2">분</h4>
                <div className="grid grid-cols-6 gap-2">
                    {minutes.map((minute) => (
                        <button
                            key={minute}
                            onClick={() => setSelectedMinute(minute)}
                            className={`p-2 rounded-lg text-sm ${
                                selectedMinute === minute
                                    ? 'bg-amber-500 text-white'
                                    : 'bg-gray-100 active:bg-gray-200'
                            }`}
                        >
                            {minute.toString().padStart(2, '0')}
                        </button>
                    ))}
                </div>
            </div>
        </SelectModal>
    );
};

export default TimePickOverlay;
